import React from "react";
import "../MainPage.css";
import { ExpandableInfoCard } from "./ExpandableInfoCard.tsx";

export const CardComponent = ({cards = []}) => {
    const handleButtonClick = (onClickFunction, event) => {
        event.preventDefault();
        if (onClickFunction && typeof onClickFunction === 'function') {
            onClickFunction();
        }
    };

    const renderDescription = (description = '') =>
        description.split('\n').map((line, index) => (
            <React.Fragment key={`${line}-${index}`}>
                {index > 0 && <br />}
                {line}
            </React.Fragment>
        ));

    const visibleCards = cards.filter(card => card.flagKey)

    return (
        <ul className="main-page-card">
            {visibleCards.map((card, index) => (
                <li key={index} className={"main-page-card-li"}>
                    <div className="image-text-container">
                        <img
                            src={card.imageSrc}
                            alt={card.imageAlt}
                            className={"logo-legal-resident"}
                        />
                        <div className="text-overlay">
                            <h1
                                className={`${card.styleCard ? "text-overlay-h1-main" : "text-overlay-h1"}${card.singleLineTitle ? " text-overlay-h1-single-line" : ""}`}
                            >
                                {card.title}
                            </h1>
                            <p className={card.styleCard ? "text-overlay-p-main" : "text-overlay-p"}>{renderDescription(card.description)}</p>
                        </div>
                        <nav className="button-overlay">
                            <div style={{display: 'flex', gap: '6px'}}>
                                <button
                                    className={`main-page-button-open${card.widePrimaryButton ? " main-page-button-open-wide" : ""}`}
                                    data-testid="sole-trader-button-open"
                                    onClick={(e) => handleButtonClick(card.primaryButtonAction, e)}
                                >
                                    {card.primaryButtonText}
                                </button>
                                {card.primaryButtonAdditionally &&
                                    <button
                                        className="main-page-button-open"
                                        onClick={(e) => handleButtonClick(card.primaryButtonAdditionallyAction, e)}
                                    >
                                        {card.primaryButtonAdditionallyText}
                                    </button>
                                }
                            </div>
                            <div className="button-overlay-content">
                                {card.dropdownButtons?.map((button, btnIndex) => (
                                    <button
                                        key={btnIndex}
                                        onClick={(e) => handleButtonClick(button.action, e)}
                                    >
                                        {button.text || button}
                                    </button>
                                ))}
                            </div>
                        </nav>
                    </div>
                    {card.expandableInfo && (
                        <div className="main-page-card-li-info">
                            <ExpandableInfoCard
                                title={card.expandableInfo.title}
                                description={card.expandableInfo.description}
                                items={card.expandableInfo.items}
                            />
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
};
